import { hotTopics, site } from "@/mocks/hotlist";

function TrendBadge({ trend }: { trend: string }) {
  if (trend === "up") {
    return (
      <span className="inline-flex items-center gap-0.5 text-xs text-accent-400">
        <i className="ri-arrow-up-line" />上升
      </span>
    );
  }
  if (trend === "down") {
    return (
      <span className="inline-flex items-center gap-0.5 text-xs text-secondary-400">
        <i className="ri-arrow-down-line" />回落
      </span>
    );
  }
  if (trend === "new") {
    return (
      <span className="inline-flex items-center gap-0.5 text-xs text-primary-400">
        <i className="ri-rocket-2-line" />新上榜
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-0.5 text-xs text-foreground-500">
      <i className="ri-subtract-line" />持平
    </span>
  );
}

export default function TopBoard() {
  const podium = hotTopics.slice(0, 3);
  const rest = hotTopics.slice(3);

  const orderClass: Record<number, string> = {
    1: "order-1 md:order-2",
    2: "order-2 md:order-1",
    3: "order-3 md:order-3",
  };

  return (
    <section id="hot" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
            <div>
              <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-400 font-medium">
                <span className="w-6 h-px bg-primary-500" />
                实时热度总榜
              </span>
              <h2 className="mt-3 font-heading text-3xl md:text-5xl font-bold text-foreground-950">
                今日热度前三甲
              </h2>
              <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
                综合各平台公开讨论量计算，每小时刷新一次。排名只反映话题被关注的程度，不代表对内容的评价。
              </p>
            </div>
            <p className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">{site.updatedAt}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {podium.map((topic) => {
              const isFirst = topic.rank === 1;
              return (
                <article
                  key={topic.rank}
                  className={`${orderClass[topic.rank]} relative rounded-lg border p-5 md:p-6 flex flex-col ${
                    isFirst
                      ? "border-primary-500/60 bg-primary-500/10 md:-mt-6 md:mb-0"
                      : "border-background-200/70 bg-background-100"
                  }`}
                >
                  <div className="flex items-start justify-between gap-3">
                    <span
                      className={`font-heading text-5xl md:text-6xl font-bold leading-none ${
                        isFirst ? "text-primary-400" : "text-background-400"
                      }`}
                    >
                      {String(topic.rank).padStart(2, "0")}
                    </span>
                    <span className="px-2.5 py-1 rounded-md bg-background-200/70 text-xs text-foreground-700 whitespace-nowrap">
                      {topic.category}
                    </span>
                  </div>

                  <h3 className="mt-5 font-heading text-lg md:text-xl font-bold text-foreground-950 leading-snug">
                    {topic.title}
                  </h3>
                  <p className="mt-3 text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                    {topic.summary}
                  </p>

                  <div className="mt-5 pt-4 border-t border-background-200/70 flex items-center justify-between gap-2">
                    <span className="text-sm md:text-base font-medium text-primary-400 tabular-nums">
                      {topic.heat}
                    </span>
                    <TrendBadge trend={topic.trend} />
                  </div>
                </article>
              );
            })}
          </div>

          <div className="mt-5 md:mt-6 rounded-lg border border-background-200/70 bg-background-100 overflow-hidden">
            <div className="px-4 md:px-6 py-4 border-b border-background-200/70 flex items-center justify-between">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                热度榜 4 - 10 名
              </h3>
              <span className="text-xs text-foreground-500">按综合关注量排序</span>
            </div>
            <ul>
              {rest.map((topic) => (
                <li
                  key={topic.rank}
                  className="px-4 md:px-6 py-4 border-b border-background-200/50 last:border-b-0 flex items-center gap-4 hover:bg-background-200/40 transition-colors"
                >
                  <span className="w-8 shrink-0 font-heading text-lg md:text-xl font-bold text-foreground-500 tabular-nums">
                    {topic.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="font-medium text-sm md:text-base text-foreground-950 truncate">
                      {topic.title}
                    </p>
                    <p className="mt-1 text-xs text-foreground-600 truncate hidden sm:block">
                      {topic.summary}
                    </p>
                  </div>
                  <div className="hidden lg:flex items-center gap-2 shrink-0">
                    {topic.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 rounded-md bg-secondary-500/10 text-xs text-secondary-300 whitespace-nowrap"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex flex-col items-end shrink-0 w-20 md:w-24">
                    <span className="text-xs md:text-sm font-medium text-primary-400 tabular-nums">
                      {topic.heat}
                    </span>
                    <TrendBadge trend={topic.trend} />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}